// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"7418":"settings-apps-view","8351":"settings-users"}[chunkId] || chunkId) + "-" + chunkId + ".js?v=" + {"6799":"00434e4baa0d8e7b79f1","7418":"4ade86747cf564489847","8351":"8b7284eb096e5c63052f"}[chunkId] + "";
};